const sfs_progress = {
    init: () => {
  
  
        if ($('.shopify-section .sfs-progress')[0]) {
    
            $('.shopify-section .sfs-progress').each(function() {
                let section_id = $(this).data('section-id');
                let parent = `.sfs-progress[data-section-id="${section_id}"]`;
    
                const barParentEl           = document.querySelector(`${parent} [sfs-progress-bar-wrapper]`),
                      dotParentEl           = document.querySelector(`${parent} [sfs-progress-dot-wrapper]`),
                      barEl                 = document.querySelector(`${parent} [sfs-progress-bar-actual]`),
                      labelTopEl            = document.querySelector(`${parent} [sfs-progress-bar-wrapper] .label-top`),
                      labelBottomEl         = document.querySelector(`${parent} [sfs-progress-bar-wrapper] .label-bottom`),
                      labelTopNumEl         = document.querySelector(`${parent} [sfs-progress-donated]`),
                      labelTopNumFormat     = parseInt(labelTopNumEl.textContent).toLocaleString('en', {useGrouping:true}),
                      donated               = barParentEl.getAttribute('data-donated'),
                      target                = barParentEl.getAttribute('data-target'),
                      percent               = Math.max(donated / target * 100, 20),
                      awayNumEl             = document.querySelector(`${parent} [sfs-progress-away]`),
                      awayNumFormat         = parseInt(awayNumEl.textContent).toLocaleString('en', {useGrouping:true});

                labelTopNumEl.textContent   = labelTopNumFormat;
                awayNumEl.textContent       = awayNumFormat;

                console.log('percent', percent)

                function animate()
                {
                    setTimeout(() => {
                        dotParentEl.style.left = `${percent}%`;
                        barEl.style.width = `${percent}%`;
                    }, 500);
    
                    setTimeout(() => {
                        labelTopEl.style.opacity = `1`;
                        labelBottomEl.style.opacity = `1`;
                    }, 2500);
                }

                const observer = new IntersectionObserver((entries, observer) => {
                    if (!entries[0].isIntersecting) return;
                    animate();
                }, { threshold: 1 });

                observer.observe(barParentEl);
    
            });

        }
  
  
    }
};
export default sfs_progress;